import { Injectable } from '@angular/core';
import {
  BaseService,
  HttpClient,
  HttpHeaders,
  HttpParams,
} from './base.service';
import { IPurchaseOrderItem } from '../shared/api';
import { AccountService } from './account.service';

@Injectable()
export class PurchaseOrderItemService extends BaseService<IPurchaseOrderItem> {
  constructor(accountService: AccountService, http: HttpClient) {
    super(accountService, http, 'purchaseOrderItem');
  }
}

export { IPurchaseOrderItem } from '../shared/api';
